import { useMutation, useQuery } from '@tanstack/react-query';
import { TCustomQueryProps } from '@/type/hooks.types';
import { useQueryClient } from '@tanstack/react-query';
import { TRequestedAppUpdateSchema } from '@/schemas/requested-app-update/requested-app-update.schema';
import {
  upsertRequestedAppUpdate,
  getFirstRequestedAppUpdate,
} from '@/api/requested-app-update/requested-app-update';
import { ErrorResponse } from '@/utils/axios.http';

export const useUpsertRequestedAppUpdate = ({
  handleSuccess,
  handleError,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestedAppUpdate?: TRequestedAppUpdateSchema) =>
      upsertRequestedAppUpdate(requestedAppUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getFirstRequestedAppUpdate'],
      });

      handleSuccess?.();
    },
    onError: (err: ErrorResponse) => {
      handleError?.(err);
      console.error('Error when upserting requested app update:', err.error);
    },
  });
};

export const useGetFirstRequestedAppUpdate = () => {
  return useQuery({
    queryKey: ['getFirstRequestedAppUpdate'],
    queryFn: () => getFirstRequestedAppUpdate(),
  });
};
